import { useCallback } from 'react';

import { ExternalOfferFragment } from '@ocx/graphql';
import { ExternalBannerCard } from './components';
import { useLogOfferActivity } from '../../../../modules/external-loyalty';
import { useExternalBannerDetailsPopup } from '../../../../components/modals';

export type ExternalBannerCardControllerProps = {
  banner: ExternalOfferFragment;
  isAltriaOffersUnavailableNearby?: boolean;
};

export const ExternalBannerCardController = ({
  banner,
  isAltriaOffersUnavailableNearby,
}: ExternalBannerCardControllerProps) => {
  const { open: openExternalBannerDetailsPopup } = useExternalBannerDetailsPopup();
  const { logClick, logImpression } = useLogOfferActivity();

  const onBannerCardClick = useCallback(
    (trackingId: string) => {
      logClick(trackingId, banner.externalCampaignId, banner.bannerConfigurationUuid);
      openExternalBannerDetailsPopup({ banner, isAltriaOffersUnavailableNearby });
    },
    [banner, logClick, openExternalBannerDetailsPopup, isAltriaOffersUnavailableNearby],
  );

  const onImpression = useCallback(
    (offerId: string) => {
      logImpression(offerId, banner.externalCampaignId, banner.bannerConfigurationUuid);
    },
    [banner.bannerConfigurationUuid, banner.externalCampaignId, logImpression],
  );

  return (
    <ExternalBannerCard
      trackingId={banner.trackingId}
      content={banner.content}
      isAltriaOffersUnavailableNearby={isAltriaOffersUnavailableNearby}
      onImpression={onImpression}
      onClick={onBannerCardClick}
    />
  );
};
